export function extractDomain(url: string) {
  return url.replace(/^(?:https?:\/\/)?(?:[^/]+\.)?([^./]+\.[^./]+).*$/, '$1');
}
